import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SectionLevelProvider } from './sectionLevel';
export var Body = React.forwardRef(function Body(_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement("body", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: 1
  }, children));
});
Body.displayName = 'Body';
export var Blockquote = React.forwardRef(function Blockquote(_ref2, ref) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React.createElement("blockquote", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: 1
  }, children));
});
Blockquote.displayName = 'Blockquote';
export var Details = React.forwardRef(function Details(_ref3, ref) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement("details", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: 1
  }, children));
});
Details.displayName = 'Details';
export var Dialog = React.forwardRef(function Dialog(_ref4, ref) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement("dialog", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: 1
  }, children));
});
Dialog.displayName = 'Dialog';
export var Fieldset = React.forwardRef(function Fieldset(_ref5, ref) {
  var children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/React.createElement("fieldset", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: 1
  }, children));
});
Fieldset.displayName = 'Fieldset';
export var Figure = React.forwardRef(function Figure(_ref6, ref) {
  var children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["children"]);

  return /*#__PURE__*/React.createElement("figure", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: 1
  }, children));
});
Figure.displayName = 'Figure';
export var Td = React.forwardRef(function Td(_ref7, ref) {
  var children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement("td", _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SectionLevelProvider, {
    value: 1
  }, children));
});
Td.displayName = 'Td';